import React, { useState } from 'react';
import { uploadAPI } from '../services/api';

const PersonalizeStep = ({ personalization, setPersonalization, onNext, onBack }) => {
  const [logoUploading, setLogoUploading] = useState(false);
  const colors = [
    { name: 'Purple', value: '#667eea' },
    { name: 'Pink', value: '#ed64a6' },
    { name: 'Blue', value: '#4299e1' },
    { name: 'Green', value: '#48bb78' },
    { name: 'Orange', value: '#ed8936' },
    { name: 'Red', value: '#f56565' },
    { name: 'Teal', value: '#38b2ac' },
    { name: 'Yellow', value: '#ecc94b' }
  ];

  const handleChange = (field, value) => {
    setPersonalization(prev => {
      const newState = {
        ...prev,
        [field]: value
      };
      return newState;
    });
  };

  const handleLogoUpload = async (file) => {
    if (!file) {
      handleChange('logo', '');
      handleChange('logoUUID', '');
      return;
    }

    // Check file size (limit to 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Logo file size must be less than 5MB');
      return false;
    }
    
    // Check file type
    if (!file.type.startsWith('image/')) {
      alert('Please select a valid image file');
      return false;
    }

    setLogoUploading(true);
    
    try {
      // Get presigned URL for logo upload
      const presignedResponse = await uploadAPI.getPresignedUrl(
        file.name,
        file.type,
        'logo'
      );

      // Upload to S3
      await uploadAPI.uploadToS3(presignedResponse.data.presigned_url, file);

      // Confirm upload and get UUID
      const confirmResponse = await uploadAPI.confirmUpload(
        presignedResponse.data.file_key,
        file.name,
        file.type,
        'logo',
        'User Logo'
      );
      
      // Set the logoUUID first
      handleChange('logoUUID', confirmResponse.data.upload_uuid);

      // Create preview URL for display
      const reader = new FileReader();
      reader.onload = (event) => {
        handleChange('logo', event.target.result); // For preview
      };
      reader.readAsDataURL(file);

      return true;
    } catch (error) {
      console.error('Logo upload failed:', error);
      alert('Failed to upload logo. Please try again.');
      return false;
    } finally {
      setLogoUploading(false);
    }
  };

  return (
    <div className="upload-section">
      <div className="step-header-with-nav">
        <div className="navigation-buttons">
          <button className="btn-back" onClick={onBack}>
            ← Back
          </button>
        </div>
        <h2 style={{ fontSize: '24px', margin: '0' }}>
          Personalize Your Video
        </h2>
        <div className="navigation-buttons">
          <button className="btn-next" onClick={onNext}>
            Next: Generate Video →
          </button>
        </div>
      </div>
      <p style={{ textAlign: 'center', color: '#718096', marginBottom: '30px' }}>
        Add names, logos, or custom text to make it uniquely yours
      </p>

      <div className="personalization-form">
        <div className="form-group">
          <label htmlFor="names">Names (Optional)</label>
          <input
            type="text"
            id="names"
            placeholder="e.g., John & Jane, Team Awesome, Family Smith"
            value={personalization.names}
            onChange={(e) => handleChange('names', e.target.value)}
            maxLength={10}
          />
          <small style={{ color: '#718096', fontSize: '12px', marginTop: '4px', display: 'block' }}>
            Add names that will appear on the designs ({personalization.names?.length || 0}/10 characters)
          </small>
        </div>

        

        {/* <div className="form-group">
          <label>Primary Color</label>
          <div className="color-options">
            {colors.map(color => (
              <div
                key={color.value}
                className={`color-option ${personalization.color === color.value ? 'selected' : ''}`}
                style={{ background: color.value }}
                onClick={() => handleChange('color', color.value)}
                title={color.name}
              />
            ))}
          </div>
          <small style={{ color: '#718096', fontSize: '12px', marginTop: '8px', display: 'block' }}>
            Choose your preferred color theme
          </small>
        </div> */}

      </div>

    </div>
  );
};

export default PersonalizeStep;
